import React from 'react'
import styled from 'styled-components'

import { Heading2, Heading4, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-bottom: 32px;
`

const Inset = styled.div`
  position: relative;
  padding-left: 20px;
  :before {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    width: 4px;
    height: 100%;
    background-color: #bfb1ff;
  }
`

const InsetText = () => {
  return (
    <>
      <Heading>Inset text</Heading>
      <Subheading>Heading</Subheading>
      <Inset>
        <Paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua.
        </Paragraph>
      </Inset>
    </>
  )
}

export default InsetText
